import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFossaComponent } from './simple-icons-fossa.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFossaComponent ],
    exports:      [ SimpleIconsFossaComponent ],
    bootstrap:    []
})
export class SimpleIconsFossaModule {}
